//
//
//
//

import { ACTION_TOGGLE_OTHER_SITES } from '@/scripts/store/footer'
import { mapActions, mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'rb-footer-other-sites-link',
  props: {
    text: String,
  },
  computed: {
    ...mapGetters(['displayOtherSites']),
  },
  methods: {
    ...mapActions({
      toggleOtherSites: ACTION_TOGGLE_OTHER_SITES,
    }),
    toggle() {
      this.$store.dispatch(ACTION_TOGGLE_OTHER_SITES)
      if (this.displayOtherSites) {
        this.$nextTick(() => VueScrollTo.scrollTo('#rb-footer__other-sites'))
      }
    },
  },
}
